import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useFetch, useFindLinkByR } from '../../../../Fetch';
import { organizationResourceDecoder } from '../../../../Organization/Decoder';
import Message from './Message';

interface Props {
  activationsRemaining: Maybe<number>;
  title: string;
  newLicenseAllocations: number;
  allocatedLicenses: number;
}

function LicenseMessage({
  activationsRemaining,
  title,
  newLicenseAllocations,
  allocatedLicenses,
}: Props) {
  const organizationLink = useFindLinkByR({ rel: 'organization' }, currentUserStore.links);
  const state = useFetch(organizationLink, organizationResourceDecoder);

  switch (state.kind) {
    case 'loading':
    case 'errored':
      return <></>;
    case 'ready':
      return (
        <Message
          licenseFamily={state.data.payload.licenseFamily}
          activationsRemaining={activationsRemaining}
          title={title}
          newLicenseAllocations={newLicenseAllocations}
          allocatedLicenses={allocatedLicenses}
        />
      );
  }
}

export default observer(LicenseMessage);
